<div class="cx-modal-container">
    <div class="cx-modal-content">
      <div class="cx-dialog-header modal-header">
        <div class="cx-dialog-title modal-title">
          <span>{{ "userData.sessionTimeOut" | cxTranslate }}</span>
        </div>
      </div>
      <div class="cx-dialog-body modal-body">
        <div class="row">
          <div class="cx-dialog-info col-md-12">
            <p>
              {{ "userData.loggedOut" | cxTranslate }} {{ secondsToDday }} {{
              "userData.sec" | cxTranslate }} {{ "userData.stayLogIn" |
              cxTranslate }}
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-12 action-container">
            <button cxAutoFocus class="vs-text-btn" (click)="closeModal('logout')">
              {{ "userData.logOut" | cxTranslate }}
            </button>
            <button class="vs-primary-btn" (click)="closeModal('close')">
              <span> {{ "userData.stay" | cxTranslate }} </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  